import { Button, Card, Icon, Loader } from "@fanduel/og-fe-library";
import Link from "next/link";
import ErrorComponent from "@/components/empty/ErrorComponent";
import { RACING_PROJECTIONS_CTA_CLICKED } from "@/constants/amplitude";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import useUpcomingRaces from "@/utils/hooks/useUpcomingRaces";
import { handleize } from "@/utils/horseRacing";
import RaceSubtitle from "../../raceSubtitle/RaceSubtitle";
import RaceTime from "../../raceTime";
import styles from "./upcomingRaces.module.scss";

const UpcomingRaces = () => {
  const { races, isLoading, isError } = useUpcomingRaces();
  const { logAmplitudeEvent } = useAmplitude();

  return (
    <Card variant="elevation" elevation="mid">
      <div>
        <h2 className={styles.title}>Upcoming Races</h2>
      </div>
      {races ? (
        <div className={styles.raceList}>
          {races.slice(0, 3).map((race) => (
            <Link
              href={`/horse-racing/picks/${race.track?.code}/${handleize(race.track?.name ?? "")}?race=${race.number}`}
              key={`${race.number} + ${race?.track?.name} + ${race.distance}`}
            >
              <div className={styles.race}>
                <div>
                  {race.postTime ? (
                    <div className={styles.raceTime}>
                      <RaceTime postTime={race.postTime} />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className={styles.raceName}>
                    <span className={styles.trackName}>{race.track?.name}</span>
                    <span>•</span>
                    <span>{`Race ${race.number}`}</span>
                  </div>
                  <RaceSubtitle race={race} pursePrefix="$" />
                </div>
                <Icon
                  iconName="arrows.right"
                  iconColor="colorBaseGreyDarken4"
                  iconSize={17}
                />
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <>
          {isLoading ? (
            <div className={styles.loadingContainer}>
              <Loader size="medium" />
            </div>
          ) : (
            ""
          )}

          {isError ? (
            <ErrorComponent
              headline="Content failed to load"
              subtext="Please check back later."
              showCta={false}
            />
          ) : (
            ""
          )}
        </>
      )}

      <div className={styles.footer}>
        <Link href="/horse-racing/picks">
          <Button
            rightIconName="arrows.right"
            className={styles.footerButton}
            buttonStyle="Outlined"
            buttonColor="Blue"
            buttonText="View All Upcoming Races"
            onClick={() => {
              logAmplitudeEvent(RACING_PROJECTIONS_CTA_CLICKED, {
                Module: "upcoming_races",
                "Link Text": "view_all_upcoming_races",
                "Link URL": "/horse-racing/picks",
              });
            }}
          />
        </Link>
      </div>
    </Card>
  );
};

export default UpcomingRaces;
